import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IBaseResponse, IDonorConnectUser } from '@nkr/models/index';
import { IApplicationState, AppActionCreators, IAppState, DashActionCreators, IDonorConnectUserListResponse } from '@nkr/store/index';
import { Button, FormControl, InputGroup, Table } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import { toast } from 'react-toastify';
import { TableWrapper } from './styles';

interface IExtendedDonorConnectUser extends IDonorConnectUser {
    originalCaseLoad: string,
    caseLoad: string,
    changed: boolean
}

interface IProps { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonorConnectUsers: () => Promise<IDonorConnectUserListResponse>,
    updateDonorConnectCaseLoad: (userId: number, donorConnectCaseLoad: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IExtendedDonorConnectUser[]
}

class UserCaseLoadLimits extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting Donor Mentor users, one moment please...').then(() => {
            this.props.getDonorConnectUsers().then(response => {
                if (response.data.success) {
                    this.setState({
                        list: response.data.results.map(item => {
                            return {
                                ...item,
                                originalCaseLoad: item.donorConnectCaseLoad != null ? item.donorConnectCaseLoad.toString() : '',
                                caseLoad: item.donorConnectCaseLoad != null ? item.donorConnectCaseLoad.toString() : '',
                                changed: false
                            };
                        })
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handleCaseLoadLimitChange = (userId: number, newCaseLoad: string) => {
        let list = _.cloneDeep(this.state.list).map(item => {
            if (item.id == userId) {
                item.changed = item.originalCaseLoad != newCaseLoad;
                item.caseLoad = Utility.isNumber(newCaseLoad) ? newCaseLoad : ''
            }

            return item;
        });

        this.setState({
            list
        });
    }

    handleSubmit = (id: number) => {
        let { firstName, lastName, caseLoad } = this.state.list.find(x => x.id == id);

        this.props.showLoading(`Updating case load limit for ${firstName} ${lastName}, one moment please...`).then(() => {
            this.props.updateDonorConnectCaseLoad(id, parseInt(caseLoad)).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let list = this.state.list.map(x => {
                        if (x.id == id) {
                            x.donorConnectCaseLoad = x.caseLoad != '' ? parseInt(x.caseLoad) : null
                            x.changed = false;
                        }

                        return x;
                    });

                    this.setState({
                        list
                    }, () => {
                        toast.success('User case load limit updated successfully');
                    });
                } else {
                    toast.error('Unable to update user case load limit');
                }
            });
        });
    }

    render = () => {
        const list = _.orderBy(this.state.list, item=>item.lastName);

        return (
            <>
                <div className='container'>
                    <div className='row' style={{ marginTop: 10, marginBottom: 30 }}>
                        <div className='col-xs-12 col-lg-12'>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                <h1 style={{ marginBottom: 0 }}>Donor Mentor User Case Load Limits</h1>
                            </div>
                        </div>
                    </div>

                    <TableWrapper>
                        <Table striped condensed>
                            <thead>
                                <tr>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Email</th>
                                    <th>Current Case Load</th>
                                    <th style={{ width: '20%' }}>Case Load Limit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list.map(user =>
                                    <tr key={'user-' + user.id}>
                                        <td>{user.firstName}</td>
                                        <td>{user.lastName}</td>
                                        <td>{user.email}</td>
                                        <td>{user.currentCaseLoad}</td>
                                        <td>
                                            <InputGroup bsSize='sm'>
                                                <FormControl
                                                    value={user.caseLoad}
                                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => this.handleCaseLoadLimitChange(user.id, e.currentTarget.value)}
                                                />
                                                <InputGroup.Button>
                                                    <Button bsStyle='primary' disabled={!user.changed} onClick={() => this.handleSubmit(user.id)}>Save</Button>
                                                </InputGroup.Button>
                                            </InputGroup>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </TableWrapper>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { return dispatch(AppActionCreators.hideLoading()); },
        getDonorConnectUsers: () => { return dispatch(DashActionCreators.getDonorConnectUsers()); },
        updateDonorConnectCaseLoad: (userId, donorConnectCaseLoad) => { return dispatch(DashActionCreators.updateDonorConnectCaseLoad(userId, donorConnectCaseLoad)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(UserCaseLoadLimits);